// When the user triggers an action that will cause a backend recompute
// (e.g. saving an override), the form marks the window during which the
// resulting `rates_computed` notification is "expected". The notifications
// hook then silently reloads instead of showing the "New rates available"
// banner, because the user already knows new rates are coming.

let expectedUntil = 0

export function markRecomputeExpected(durationMs = 30_000): void {
  expectedUntil = Date.now() + durationMs
}

export function isRecomputeExpected(): boolean {
  return Date.now() < expectedUntil
}
